import { circleObject, drawIconRecurrence } from "../../utils/utils";
import { FabricPlugin } from "../FabricPlugin";

/**
 * @description Diagrams Pluign. Also used in SmartContractDesigner
 */
export class GeneralStartPlugin extends FabricPlugin {
  fillStyle = "#63D471";

  radius = 20;

  name = "Start";

  constructor(options, ctx, data) {
      super(options, ctx, data);
      this.points = { start: 1, end: 0, initial: 4 };
  }

  draw(additionalOptions, disabled) {
      const xCenter = this.position.x + this.size.width / 2;
      const yCenter = this.position.y + (this.size.height / 2);
      if (this.size.backgroundRadius) {
          circleObject(xCenter, yCenter, this.size.customRadiusMax + this.size.backgroundRadius, {
              fillStyle: this.size.backgroundColor
          }, this.ctx);
      }
      circleObject(xCenter, yCenter, this.size.customRadiusMax || this.radius, { fillStyle: this.fillStyle }, this.ctx);
      if (additionalOptions && additionalOptions.hasRecurrence) {
          drawIconRecurrence(xCenter, yCenter, this.radius * (45 / 100),
              { fillStyle: this.fillStyle, lineWidth: 2, strokeStyle: "#ffffff" }, this.ctx, additionalOptions.recurrenceExpired, disabled);
      }
      this.fabricPluginRedrawed();
  }

  update(options) {
      this.setPosition(options && options.position ? options.position : super.getPosition());
      this.setSize(options && options.size ? options.size : super.getSize());
  }
}
